module.exports = __webpack_public_path__ + "img/logo-melissa.d866f56c.png";